import { createReducer, createActions } from 'reduxsauce';
import { getWeekRange } from '@utils/date';

export const DISCONTINUE_STAGE = {
  TYPE: 'type',
  DATE: 'date',
  CONFIRM: 'confirm'
};

export const DISCONTINUE_TYPE = {
  PAUSE: 'pause',
  DISCONTINUE: 'discontinue'
};

const { Types, Creators } = createActions({
  resetDiscontinue: null,
  setDiscontinueStep: ['step'],
  setDiscontinueInitialStep: ['initialStep'],
  setDiscontinueDate: ['date'],
  setDiscontinueType: ['discontinueType']
});

export const DiscontinueTypes = Types;
export default Creators;

/* ------- Initial State --------- */
export const INITIAL_STATE = {
  step: DISCONTINUE_STAGE.TYPE,
  discontinueType: '',
  discontinueDate: null,
  initialStep: DISCONTINUE_STAGE.TYPE
};

/* ------- Selectors --------- */
export const DiscontinueSelectors = {
  selectCurrentStep: state => state.discontinue.step,
  selectInitialStep: state => state.discontinue.initialStep,
  selectType: state => state.discontinue.discontinueType,
  selectIsPause: state =>
    state.discontinue.discontinueType === DISCONTINUE_TYPE.PAUSE,
  selectDiscontinueDate: state => state.discontinue.discontinueDate,
  selectWeekRange: state =>
    getWeekRange(state.discontinue.discontinueDate, 1, [])
};

/* -------- Reducers ---------- */
export const setStep = (state, { step }) => {
  return {
    ...state,
    step
  };
};

export const setInitialStep = (state, { initialStep }) => {
  return {
    ...state,
    initialStep
  };
};

export const setDiscontinueType = (state, { discontinueType }) => {
  return {
    ...state,
    discontinueType
  };
};

export const setDiscontinueDate = (state, { date }) => {
  return {
    ...state,
    discontinueDate: date
  };
};

export const resetDiscontinue = () => {
  return {
    ...INITIAL_STATE
  };
};

/* -------- Hookup Reducers to Types -------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.RESET_DISCONTINUE]: resetDiscontinue,
  [Types.SET_DISCONTINUE_STEP]: setStep,
  [Types.SET_DISCONTINUE_INITIAL_STEP]: setInitialStep,
  [Types.SET_DISCONTINUE_TYPE]: setDiscontinueType,
  [Types.SET_DISCONTINUE_DATE]: setDiscontinueDate
});
